export default __webpack_public_path__ + "static/media/lazada.67b5cc15.svg";